import { get, post } from "services/network/endpoint"
import * as ActionTypes from "services/state/action-types"
import {
  SAVE_NEW_SALE_PORTABILITY_SUCCESS,
  SPECIALIST_ANALYSIS_FAIL,
  SPECIALIST_ANALYSIS_SUCCESS
} from "services/state/action-types"
import { dispatchHandler } from "services/utils/action"
import { BFF } from "../../network/routes"
import _get from "lodash/get"
import {
  ACTION_DASH,
  NUMBER_OCCURRENCES
} from "services/state/fixedVoice/constants"
import _ from "lodash"

export function portabilityInformationReturn(
  telephoneNumber,
  callback,
  callbackFail
) {
  return (dispatch) => {
    const config = {
      pathValues: { telephoneNumber },
      client: BFF
    }
    const request = get("portabilityInformationReturn", config)
    return dispatch({
      type: ActionTypes.GET_PORTABILITY_INFORMATION,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getProductFixedVoice(callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF
    }
    const request = get("getProductFixedVoice", config)
    dispatch({
      type: ActionTypes.GET_PRODUCT_FIXED_VOICE,
      payload: request
    }).then(callback)
  }
}

export function getLocationsBypostCode(postCode, callback) {
  return (dispatch) => {
    const config = {
      pathValues: { postCode },
      client: BFF
    }
    const request = get("getLocationsBypostCode", config)
    dispatch({
      type: ActionTypes.GET_LOCATION_BY_POSTCODE,
      payload: request
    }).then(callback)
  }
}

export function validateAddress(address, callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      data: address,
      client: BFF
    }

    const request = post("validateAddress", config)
    dispatch({
      type: ActionTypes.VALIDATE_ADDRESS,
      payload: request
    }).then(callback)
  }
}

export function getRangeFixa(localityCode, callback) {
  return (dispatch) => {
    const config = {
      pathValues: { localityCode },
      client: BFF
    }

    const request = get("getRangeFixa", config)
    dispatch({
      type: ActionTypes.GET_RANGE_FIXA,
      payload: request
    }).then(callback)
  }
}

export function newSalesOrder(body, callback) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      data: body,
      client: BFF
    }

    const request = post("newSalesOrder", config)
    dispatch({
      type: ActionTypes.NEW_SALES_ORDER,
      payload: request
    }).then(callback)
  }
}

export function savePartnerDocument(document) {
  return (dispatch, getState) => {
    const documentStored = _get(getState().newOrder, "documentNumber", null)

    if (document !== documentStored) {
      dispatch({
        type: ActionTypes.SAVE_DASHBOARD_DOCUMENT,
        payload: document
      })
    }
  }
}

export function getPartnerCircuit() {
  return (dispatch, getState) => {
    const circuitStored = _get(getState().newOrder, "circuit", null)

    if (!circuitStored) {
      const callback = (values) => {
        if (!_.isNil(values.payload)) {
          if (values.payload.data.length) {
            const circuit = _get(values.payload.data, "[0].circuit", "")

            dispatch({
              type: ActionTypes.GET_VALID_CIRCUITS,
              payload: circuit
            })
          }
        }
      }
      dispatch(getProductFixedVoice(callback))
    } else {
      dispatch({
        type: ActionTypes.GET_VALID_CIRCUITS,
        payload: circuitStored
      })
    }
  }
}

export function partnerLocalityUfs() {
  return (dispatch) => {
    const config = {
      params: { action: "CONSULT_UF" },
      client: BFF
    }

    const request = get("partnerLocality", config)

    dispatch({
      type: ActionTypes.GET_VALID_LOCALITIES,
      payload: request
    })
  }
}

export function partnerLocalityAreaLocals(locality) {
  return (dispatch) => {
    const config = {
      params: { uf: locality, action: "CONSULT_AREA_LOCAL" },
      client: BFF
    }

    const request = get("partnerLocality", config)

    dispatch({
      type: ActionTypes.GET_VALID_LOCALITIES,
      payload: request
    })
  }
}

export function partnerLocality(uf, areaLocal) {
  return (dispatch) => {
    const config = {
      params: { uf, areaLocal, action: "CONSULT_LOCALITY" },
      client: BFF
    }

    const request = get("partnerLocality", config)

    dispatch({
      type: ActionTypes.GET_VALID_LOCALITIES,
      payload: request
    })
  }
}

export function partnerSales(order, valuesForm, callback) {
  return (dispatch, getState) => {
    order.customerDocument = _get(
      getState().customer,
      "data.documentNumber",
      ""
    )

    const config = {
      data: order,
      client: BFF
    }

    const request = post("partnerSales", config)

    dispatch({
      type: ActionTypes.SAVE_ORDER,
      payload: valuesForm
    })

    dispatch({
      type: ActionTypes.SAVE_NEW_SALE_PORTABILITY,
      payload: request
    }).then((resp) => {
      if (resp.type === SAVE_NEW_SALE_PORTABILITY_SUCCESS) {
        const response = _get(resp.payload.data, "response")
        callback(response)
      }
    })
  }
}

export function getSpecialistOccurrences(page) {
  return (dispatch, getState) => {
    const userDocument = _get(getState().newOrder, "documentNumber", "")

    const config = {
      params: {
        userDocument,
        page: page || 1,
        recordsForPage: NUMBER_OCCURRENCES
      },
      client: BFF
    }

    const request = get("partnerOccurrences", config)

    dispatch({
      type: ActionTypes.GET_SPECIALIST_REQUESTS,
      payload: request
    })
  }
}

const factoryDash = (getState, paramsObject, actionParam) => {
  const partnerDoc = _get(paramsObject, "partnerDoc", "")
  const documentStored = _get(getState().newOrder, "documentNumber", "")
  const fallbackParent = _get(getState().customer, "data.documentNumber", "")
  const activeCnpj = documentStored || fallbackParent

  const locality = _get(paramsObject, "locality", "")
  const status = _get(paramsObject, "status", "")
  const phone = _get(paramsObject, "partnerPhone", "")
  const page = _get(paramsObject, "page", 1)

  return {
    partnerDocument: activeCnpj,
    partnerCircuit: _get(getState().newOrder, "circuit", ""),
    partnerAssigneeDoc: partnerDoc,
    partnerCodLocality: locality,
    partnerStatus: status || "",
    partnerAction: actionParam,
    pageOrder: page,
    partnerPhone: phone
  }
}

export function getCustomersFixedVoice(paramsCustomers) {
  return (dispatch, getState) => {
    const params = factoryDash(
      getState,
      paramsCustomers,
      ACTION_DASH.DASH_ASSET_ASSIGNEE_COUNT
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    dispatch({
      type: ActionTypes.GET_DASHBOARD_NUMBERS_OR_CLIENTS,
      payload: request
    })
  }
}

export function getStatusAssetsPartner(partnerDoc) {
  return (dispatch, getState) => {
    const params = factoryDash(
      getState,
      { partnerDoc },
      ACTION_DASH.DASH_ASSET_PARTNER_COUNT
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    dispatch({
      type: ActionTypes.GET_DASHBOARD_COUNT_STATUS,
      payload: request
    })
  }
}

export function getStatusAssetCount(partnerDoc) {
  return (dispatch, getState) => {
    const params = factoryDash(
      getState,
      { partnerDoc },
      ACTION_DASH.DASH_ASSET_ASSIGNEE_COUNT_BY_STATUS
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    dispatch({
      type: ActionTypes.GET_DASHBOARD_COUNT_STATUS_DETAIL,
      payload: request
    })
  }
}

export function getStatusOrdersCount(partnerDoc) {
  return (dispatch, getState) => {
    const params = factoryDash(
      getState,
      { partnerDoc },
      ACTION_DASH.DASH_ORDERS_ASSIGNEE_COUNT_BY_STATUS
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    dispatch({
      type: ActionTypes.GET_DASHBOARD_COUNT_STATUS_DETAIL,
      payload: request
    })
  }
}

export function getClientDetailsAssets(paramsClientDetails) {
  return (dispatch, getState) => {
    const documentAssignee = _get(
      getState().customersFixedVoice,
      "customerDetails.document",
      ""
    )

    const params = factoryDash(
      getState,
      { ...paramsClientDetails, partnerDoc: documentAssignee },
      ACTION_DASH.DASH_ASSET_ASSIGNEE_BY_TN
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    dispatch({
      type: ActionTypes.GET_DASHBOARD_NUMBERS_DETAIL,
      payload: request
    })
  }
}

export function getClientDetailsOrders(paramsClientDetails) {
  return (dispatch, getState) => {
    const documentAssignee = _get(
      getState().customersFixedVoice,
      "customerDetails.document",
      ""
    )

    const params = factoryDash(
      getState,
      { ...paramsClientDetails, partnerDoc: documentAssignee },
      ACTION_DASH.DASH_ORDERS_ASSIGNEE_COUNT_BY_TN
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    dispatch({
      type: ActionTypes.GET_DASHBOARD_NUMBERS_DETAIL,
      payload: request
    })
  }
}

export function getClientDetails(customer) {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.GET_CUSTOMER_DETAILS,
      payload: customer
    })
  }
}

export function newSpecialistAnalysis(order, body, callback) {
  return (dispatch) => {
    let response, error, respError

    const config = {
      data: body,
      client: BFF
    }

    const request = post("partnerOrderService", config)

    dispatch({
      type: ActionTypes.SAVE_ORDER,
      payload: order
    })

    dispatch({
      type: ActionTypes.SPECIALIST_ANALYSIS,
      payload: request
    }).then((resp) => {
      switch (resp.type) {
        case SPECIALIST_ANALYSIS_SUCCESS:
          response = _get(resp.payload.data, "response")
          callback(response)
          break
        case SPECIALIST_ANALYSIS_FAIL:
          error = _get(resp.error.response, "data")
          respError = _get(error, "response")
          callback(respError || error)
          break
      }
    })
  }
}

export function getEditNumbers(paramsEditNumbers) {
  return (dispatch, getState) => {
    const documentAssignee = _get(
      getState().customersFixedVoice,
      "customerDetails.document",
      ""
    )
    const actionStatus = paramsEditNumbers.type === "ASSET" ? "ATIVO" : ""
    const actionSelected =
      paramsEditNumbers.type === "ASSET"
        ? ACTION_DASH.DASH_ASSET_ASSIGNEE_BY_TN
        : ACTION_DASH.DASH_ORDERS_ASSIGNEE_COUNT_BY_TN

    const params = factoryDash(
      getState,
      {
        ...paramsEditNumbers,
        partnerDoc: documentAssignee,
        status: actionStatus
      },
      actionSelected
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    return dispatch({
      type: ActionTypes.GET_ACTIONS_NUMBERS_OR_CLIENTS,
      payload: request
    })
  }
}

export function postEditClient(editClientPayload, callback) {
  return (dispatch, getState) => {
    const circuit = _get(getState().newOrder, "circuit", "")
    const payload = { ...editClientPayload, circuitKey: circuit }

    const config = {
      data: payload,
      client: BFF
    }
    const request = post("editClientDashboard", config)

    return dispatch({
      type: ActionTypes.SAVE_ACTIONS_EDIT_CLIENT,
      payload: request
    })
  }
}

export function postRescheduleOrSuspend(editClientPayload) {
  return (dispatch, getState) => {
    const partnerDocument = _get(getState().customer, "data.documentNumber", "")
    const payload = { ...editClientPayload, partnerDocument }

    const config = {
      data: payload,
      client: BFF
    }

    const request = post("partnerRescheduleSuspend", config)

    return dispatch({
      type: ActionTypes.SAVE_RESCHEDULE_SUSPEND,
      payload: request
    })
  }
}

export function postCancelPortability(editClientPayload) {
  return (dispatch, getState) => {
    const partnerDocument = _get(getState().customer, "data.documentNumber", "")
    const payload = { ...editClientPayload, partnerDocument }

    const config = {
      data: payload,
      client: BFF
    }

    const request = post("partnerCancel", config)

    return dispatch({
      type: ActionTypes.SAVE_RESCHEDULE_SUSPEND,
      payload: request
    })
  }
}

export function getExportDashNumbers(paramsClientExport) {
  return (dispatch, getState) => {
    const documentAssignee = _get(
      getState().customersFixedVoice,
      "customerDetails.document",
      ""
    )

    const exportType = paramsClientExport.type

    let actionSelected
    switch (exportType) {
      case "ASSET":
        actionSelected = ACTION_DASH.EXPORT_DASH_ASSET_ASSIGNEE_COUNT
        break
      case "ORDERS_DETAILS":
        actionSelected = ACTION_DASH.EXPORT_DASH_ORDERS_ASSIGNEE_COUNT_BY_TN
        break
      case "ASSET_DETAILS":
        actionSelected = ACTION_DASH.EXPORT_DASH_ASSET_ASSIGNEE_BY_TN
    }

    const params = factoryDash(
      getState,
      {
        ...paramsClientExport,
        partnerDoc: exportType !== "ASSET" ? documentAssignee : ""
      },
      actionSelected
    )

    const config = {
      params,
      client: BFF
    }

    const request = get("partnerDashboard", config)

    return dispatch({
      type: ActionTypes.GET_ACTIONS_EXPORT_CSV,
      payload: request
    })
  }
}

export function getDatesReschedule(protocol) {
  return (dispatch) => {
    const config = {
      pathValues: { protocol },
      client: BFF
    }

    const request = get("partnerDatesReschedule", config)

    dispatch({
      type: ActionTypes.GET_RESCHEDULE_DATES,
      payload: request
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/state/fixedVoice/action.js